import MeilleursTestsLogo from './logo'
import {meilleursTestsStylesFR} from './styles'

const baseConfig = {
  domainName: 'meilleurstests' as const,
  domainType: 'insider' as const,
  siteName: 'Meilleurs Tests',
  favicon: '/favicons/meilleurstests.png',
}

const localeConfigs = {
  fr: {
    measurementId: 'G-3G1LBKEZHZ',
    camelCaseUrl: 'MeilleursTests.fr',
    logo: <MeilleursTestsLogo className="size-10 shrink-0 tablet:size-8" locale="fr" />,
    title: (category: string, _count: string) =>
      `Tests Complets ${category}, Avis Fiables et Comparatifs - MeilleursTests.fr`,
    description: (
      _category?: string,
      _count?: string,
    ) => `Explorez des tests approfondis, lisez nos avis objectifs et comparez les meilleurs produits pour acheter en toute confiance et au meilleur tarif.
`,
    styles: meilleursTestsStylesFR,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
